// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { FieldOptionResponse } from './field-option-response';

/** See com.rev360.pms.api.controller.encounter.dynamic.form.FieldDefinitionResponse */
/* istanbul ignore next */
@GandalfModel
export class FieldDefinitionResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Number })
	masterIdentifier!: number | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfArray(FieldOptionResponse)
	values!: FieldOptionResponse[] | null;

}
